const key = 'kHCbcLMO1NZnOdY3e9mBKUfQY4PgcKevsNXeVQmc'

export {
  key
}